// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__3u7NK","footer":"ModalFilter_footer__2tocM"};